<div class="popover-content">
    <!-- Use Angular's ng-container to insert dynamic content -->
    <ng-container *ngIf="content">
      <div [innerHTML]="content"></div>
    </ng-container>
  </div>
  